<div class="card mb-5 mb-xl-8">
  <div class="card-header border-0 pt-5">
    <h3 class="card-title align-items-start flex-column">
      <span class="card-label fw-bold fs-3 mb-1">
        {{ "organization.editOrganization" | translate }}
      </span>
    </h3>
    <button
      type="button"
      class="btn-close cursor-pointer"
      (click)="onCancel()"
      aria-label="Close"
    ></button>
  </div>

  <div class="card-body py-3">
    <div *ngIf="isLoading" class="d-flex justify-content-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ "loading" | translate }}...</span>
      </div>
    </div>

    <form *ngIf="!isLoading" [formGroup]="editForm">
      <div class="mb-3">
        <label class="form-label required">{{ "name" | translate }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="name"
          [placeholder]="'organization.organizationName' | translate"
        />
        <div *ngIf="isControlInvalid('name')" class="text-danger fs-7 mt-1">
          <ng-container *ngIf="editForm.get('name')?.hasError('required')">
            {{ "validation.required" | translate }}
          </ng-container>
          <ng-container *ngIf="editForm.get('name')?.hasError('minlength')">
            {{ "validation.minLength" | translate: { length: 2 } }}
          </ng-container>
          <ng-container *ngIf="editForm.get('name')?.hasError('maxlength')">
            {{ "validation.maxLength" | translate: { length: 100 } }}
          </ng-container>
          <ng-container *ngIf="editForm.get('name')?.hasError('pattern')">
            {{ "validation.onlyLetters" | translate }}
          </ng-container>
        </div>
      </div>

      <div class="row mb-3 gx-5">
        <div class="col-md-6">
          <label class="form-label required">{{
            "customerCode" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            formControlName="customerCode"
            [placeholder]="'customerCode' | translate"
          />
          <div
            *ngIf="isControlInvalid('customerCode')"
            class="text-danger fs-7 mt-1"
          >
            <ng-container
              *ngIf="editForm.get('customerCode')?.hasError('required')"
            >
              {{ "validation.required" | translate }}
            </ng-container>
            <ng-container
              *ngIf="editForm.get('customerCode')?.hasError('minlength')"
            >
              {{ "validation.minLength" | translate: { length: 2 } }}
            </ng-container>
            <ng-container
              *ngIf="editForm.get('customerCode')?.hasError('maxlength')"
            >
              {{ "validation.maxLength" | translate: { length: 100 } }}
            </ng-container>
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label required">{{ "email" | translate }}</label>
          <input
            type="email"
            class="form-control"
            formControlName="email"
            [placeholder]="'email' | translate"
          />
          <div *ngIf="isControlInvalid('email')" class="text-danger fs-7 mt-1">
            <ng-container *ngIf="editForm.get('email')?.hasError('required')">
              {{ "emailIsRequired" | translate }}
            </ng-container>
            <ng-container *ngIf="editForm.get('email')?.hasError('email')">
              {{ "validation.validEmail" | translate }}
            </ng-container>
            <ng-container *ngIf="editForm.get('email')?.hasError('maxlength')">
              {{ "validation.maxLength" | translate: { length: 50 } }}
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row mb-3 gx-5">
        <div class="col-md-6">
          <label class="form-label required">{{
            "phoneNumber" | translate
          }}</label>
          <ngx-intl-tel-input
            appPhoneInput
            [cssClass]="'form-control'"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name,
            ]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="defaultCountry"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="true"
            name="editPhone"
            formControlName="phone"
          ></ngx-intl-tel-input>
          <div *ngIf="isControlInvalid('phone')" class="text-danger fs-7 mt-1">
            <span *ngIf="editForm.get('phone')?.hasError('required')">
              {{ "phoneNumberIsRequired" | translate }}
            </span>
            <span
              *ngIf="editForm.get('phone')?.hasError('validatePhoneNumber')"
            >
              {{ "phoneNumberIsNotValid" | translate }}
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label required">{{
            "organization.timeZone" | translate
          }}</label>
          <app-select
            formControlName="timeZone"
            [items]="timeZones"
            bindLabel="label"
            bindValue="name"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'organization.timeZone' | translate"
          ></app-select>
          <div
            *ngIf="isControlInvalid('timeZone')"
            class="text-danger fs-7 mt-1"
          >
            <ng-container
              *ngIf="editForm.get('timeZone')?.hasError('required')"
            >
              {{ "validation.required" | translate }}
            </ng-container>
            <ng-container
              *ngIf="editForm.get('timeZone')?.hasError('maxlength')"
            >
              {{ "validation.maxLength" | translate: { length: 70 } }}
            </ng-container>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label required">{{
          "organization.contactPerson" | translate
        }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="contactPerson"
          [placeholder]="'organization.contactPerson' | translate"
        />
        <div
          *ngIf="isControlInvalid('contactPerson')"
          class="text-danger fs-7 mt-1"
        >
          <ng-container
            *ngIf="editForm.get('contactPerson')?.hasError('required')"
          >
            {{ "validation.required" | translate }}
          </ng-container>
          <ng-container
            *ngIf="editForm.get('contactPerson')?.hasError('minlength')"
          >
            {{ "validation.minLength" | translate: { length: 2 } }}
          </ng-container>
          <ng-container
            *ngIf="editForm.get('contactPerson')?.hasError('maxlength')"
          >
            {{ "validation.maxLength" | translate: { length: 100 } }}
          </ng-container>
          <ng-container
            *ngIf="editForm.get('contactPerson')?.hasError('pattern')"
          >
            {{ "validation.onlyLetters" | translate }}
          </ng-container>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label required">{{
          "organization.address" | translate
        }}</label>
        <textarea
          class="form-control"
          rows="2"
          formControlName="address"
          [placeholder]="'organization.address' | translate"
        ></textarea>
        <div *ngIf="isControlInvalid('address')" class="text-danger fs-7 mt-1">
          <ng-container *ngIf="editForm.get('address')?.hasError('required')">
            {{ "validation.required" | translate }}
          </ng-container>
          <ng-container *ngIf="editForm.get('address')?.hasError('maxlength')">
            {{ "validation.maxLength" | translate: { length: 1000 } }}
          </ng-container>
        </div>
      </div>

      <div class="d-flex flex-stack">
        <div class="me-5">
          <label class="fs-6 fw-bold text-gray-800 d-block">
            {{ "organization.enableAssessment" | translate }}
          </label>
          <div class="fs-7 text-gray-500">
            {{ "organization.assessmentDescription" | translate }}
          </div>
        </div>

        <div class="form-check form-switch form-check-custom form-check-solid">
          <input
            class="form-check-input h-25px w-45px cursor-pointer"
            type="checkbox"
            formControlName="isAssessmentActive"
            id="assessmentSwitchCreate"
          />
          <label
            class="form-check-label fw-bold text-gray-600 ms-3"
            for="assessmentSwitchCreate"
          >
            {{
              (editForm.get("isAssessmentActive")?.value ? "yes" : "no")
                | translate
            }}
          </label>
        </div>
      </div>
    </form>
  </div>

  <div class="card-footer d-flex justify-content-end gap-3 border-0 pt-0">
    <button
      type="button"
      class="btn btn-secondary cursor-pointer"
      (click)="onCancel()"
    >
      {{ "cancel" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary cursor-pointer"
      (click)="submitEdit()"
      [disabled]="isSubmitting || isLoading || editForm.invalid"
    >
      <span *ngIf="!isSubmitting">{{ "save" | translate }}</span>
      <span
        *ngIf="isSubmitting"
        class="spinner-border spinner-border-sm align-middle ms-2"
      ></span>
    </button>
  </div>
</div>
